module.exports = __webpack_public_path__ + "assets/img/InvestorRelations.150b4d66.png";